
import React, { useState } from 'react';
import useMounted from '../../hooks/useMounted';
import { post } from '../../helpers/api_helper';
import { utc_local, amountFormatUse } from '../../helpers/Helper';
import { GET_DASHBOARD_DATA, GET_CREAT_ORDER, GET_UPDATE_ORDER, POST_PDF_INVOICE } from '../../helpers/url_helper';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import Loader from './../../components/Loader';

const Dashboard = (props) => {
    const { t } = useTranslation();

    const [ShowLoader, SetShowLoader] = useState(false);
    const [totalIssuedCheque, SetTotalIssuedCheque] = useState(0);
    const [totalCredit, SetTotalCredit] = useState(0);
    const [active_plan_info, SetActive_plan_info] = useState(null);
    const [planList, SetPlanList] = useState([]);
    const [OrderList, SetOrderList] = useState([]);
    const [invoiceList, SetInvoiceList] = useState([]);
    const [planInfo, SetPlanInfo] = useState({});

    const [ButtonDisabled, SetButtonDisabled] = useState(false);
    const [ThankMessage, SetThankMessage] = useState(false);
    const [form_inputs, setInputs] = useState({ transactionId: '' });



    useMounted(() => {
        async function get_detaile() {
            getHomeDate();
        }
        get_detaile();
    }, [])

    const getHomeDate = async () => {
        SetShowLoader(true);
        var res_data = await post(GET_DASHBOARD_DATA, {});
        if (res_data.status) {
            SetTotalIssuedCheque(res_data.data.totalIssuedCheque);
            SetTotalCredit(res_data.data.totalCredit);
            SetActive_plan_info(res_data.data.active_plan_info);
            SetPlanList(res_data.data.plan_list);
            SetOrderList(res_data.data.order_list);
            SetInvoiceList(res_data.data.invoice_list);
        } else {
            toast.error(res_data.message);
        }
        SetShowLoader(false);
    }

    const openModel = async (planInfo) => {
        SetThankMessage(false);
        setInputs({ transactionId: '' })
        var api_res = await post(GET_CREAT_ORDER, { planId: planInfo.planId });
        SetButtonDisabled(true);
        if (api_res.status) {
            const myModalEl = document.getElementById('paymentModal');
            new window.bootstrap.Modal(myModalEl).show();
            SetPlanInfo(api_res.data.planInfo);
        } else {
            toast.error(api_res.message);
        }
        SetButtonDisabled(false);
    }

    // input text change handler
    const handleInputChange = (event) => {
        event.persist();
        setInputs(inputs => ({ ...form_inputs, [event.target.name]: event.target.value }));
    }

    const submit = async () => {
        if (!form_inputs.transactionId) {
            toast.error('Transaction id is required');
            return;
        }

        SetButtonDisabled(true);
        form_inputs.orderId = planInfo.orderId;
        var res_data = await post(GET_UPDATE_ORDER, form_inputs);
        if (res_data.status) {
            getHomeDate();
            SetThankMessage(true)
        } else {
            toast.error(res_data.message);
        }
        SetButtonDisabled(false);

    }

    const [visible, setVisible] = useState(true);
    if (!visible) return null;

    return (
        <>
            {ShowLoader && <Loader />}

            {active_plan_info && !active_plan_info.plan_status &&
                <div className="alert alert-danger alert-dismissible fade show" role="alert">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-exclamation-triangle-fill flex-shrink-0 me-3" viewBox="0 0 16 16" role="img" aria-label="Warning:">
                        <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"></path>
                    </svg>
                    <span dangerouslySetInnerHTML={{ __html: t('homePage.subscriptionExpired') }}></span>
                    <button type="button" className="btn-close" onClick={() => setVisible(false)} data-bs-dismiss="alert" aria-label="Close"></button>
                </div>
            }

            {active_plan_info && active_plan_info.plan_status &&
                <div className='row'>
                    <div className="col-sm-6 col-lg-3 mb-4">
                        <div className="card card-border-shadow-primary h-100">
                            <div className="card-body">
                                <div className=" mb-2 text-center">
                                    <h4 className="mb-2 mt-3"> {totalIssuedCheque} / {(totalCredit > 0) ? totalCredit : <i className='bx bx-infinite' style={{ "fontSize": "25px" }}></i>}</h4>
                                    <p className="mb-0">{t('homePage.totalLimit')}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-6 col-lg-3 mb-4">
                        <div className="card card-border-shadow-primary h-100">
                            <div className="card-body">
                                <div className=" mb-0 pb-0">
                                    <p className='mb-0'><small>{t('homePage.activePlan')}</small></p>
                                    <h4 className="mb-0 text-primary">{active_plan_info.name}</h4>
                                    {active_plan_info.chequePrint > 0 && <p className="mb-0"><small>Up to {active_plan_info.chequePrint} Cheque Printing</small></p>}
                                    {active_plan_info.chequePrint === 0 && <p className="mb-0"><small>Unlimited Cheque Printing</small></p>}
                                    <p className='mb-0'><small>{utc_local(active_plan_info.startDate, 'DD MMM')} To {utc_local(active_plan_info.endDate, 'DD MMM YYYY')}</small></p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-sm-6 col-lg-3 mb-4">
                        <div className="card card-border-shadow-primary h-100">
                            <div className="card-body d-flex align-items-center justify-content-between">
                                <div className="d-flex align-items-center">
                                    <i className="bx bxl-windows" style={{ fontSize: "50px", marginRight: "10px" }}></i>
                                </div>
                                <div>
                                    <p className='mb-0'>Download Desktop App</p>
                                    <p className='mb-2'><small>V 1.0.0</small></p>
                                    <a href="https://chequeprint.co.in/cheque-print-setup-1.0.0.exe" className="btn btn-outline-primary btn-sm">
                                        <i className='bx bx-download me-2'></i> Download
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-sm-6 col-lg-3 mb-4">
                        <div className="card card-border-shadow-primary h-100" style={{ position: "relative" }}>
                            <span className="badge bg-danger" style={{
                                position: "absolute",
                                top: "10px",
                                right: "10px",
                                fontSize: "10px",
                                animation: "blink 1.5s linear infinite",
                                zIndex: "1"
                            }}>NEW</span>
                            <style>
                                {`
                                    @keyframes blink {
                                        0%, 49% { opacity: 1; }
                                        50%, 100% { opacity: 0.3; }
                                    }
                                `}
                            </style>
                            <div className="card-body d-flex align-items-center justify-content-between">
                                <div className="d-flex align-items-center">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="70" viewBox="0 0 200 200" style={{ marginRight: "10px" }}>
                                        <defs>
                                            <style>
                                                {`.staff-hisab-icon { fill: #318af0; }`}
                                            </style>
                                        </defs>
                                        <circle cx="100" cy="50" r="25" className="staff-hisab-icon"/>
                                        <path d="M70 90 Q70 75 100 75 Q130 75 130 90 L130 105 L70 105 Z" className="staff-hisab-icon"/>
                                        <rect x="40" y="115" width="120" height="70" rx="8" fill="none" stroke="#318af0" strokeWidth="6"/>
                                        <line x1="40" y1="135" x2="160" y2="135" stroke="#318af0" strokeWidth="6"/>
                                        <circle cx="65" cy="155" r="12" fill="none" stroke="#318af0" strokeWidth="5"/>
                                        <polyline points="60,155 64,160 72,150" stroke="#318af0" strokeWidth="4" fill="none"/>
                                        <text x="90" y="165" fontSize="28" fill="#318af0" fontWeight="bold">₹</text>
                                        <line x1="115" y1="156" x2="145" y2="156" stroke="#318af0" strokeWidth="4"/>
                                        <line x1="115" y1="165" x2="140" y2="165" stroke="#318af0" strokeWidth="4"/>
                                        <line x1="115" y1="174" x2="145" y2="174" stroke="#318af0" strokeWidth="4"/>
                                    </svg>
                                </div>
                                <div>
                                    {/* <p className='mb-0'>Other Services</p> */}
                                    <p className='mb-2'><small>Staff Management</small></p>
                                    <a href="https://staffhisab.in/" target="_blank" rel="noreferrer" className="btn btn-outline-primary btn-sm">
                                        <i className='bx bx-link-external me-2'></i> Staff Hisab
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }

            <div className='row '>
                {planList && planList.map((plan) => {
                    return (
                        <div className="col-sm-6 col-lg-3 mb-4" key={plan.planId}>
                            <div className="card card-border-shadow-primary h-100">
                                <div className="card-body">
                                    <div className=" mb-2 text-center">
                                        <h6 className="mb-3 text-uppercase"><b>{plan.name}</b></h6>
                                        <h1 className="mb-0"><b>₹ {plan.price}</b></h1>

                                        {plan.freeDay > 0 && <p><small>{plan.freeDay} Days</small></p>}
                                        {plan.freeDay <= 0 && <p><small>/Annually</small></p>}

                                        {plan.chequePrint > 0 && <p><small>Up to {plan.chequePrint} cheque printing</small></p>}
                                        {plan.chequePrint === 0 && <p><small>Unlimited Cheque Printing</small></p>}
                                        {(
                                            !active_plan_info.plan_status || 
                                            (active_plan_info.plan_status && parseInt(active_plan_info.planId) !== parseInt(plan.planId)) || 
                                            (parseInt(active_plan_info.planId) === parseInt(plan.planId) && totalCredit > 0 && totalIssuedCheque >= totalCredit)
                                        ) && <button onClick={() => { openModel(plan) }} type="button" disabled={ButtonDisabled} className="btn btn-primary btn-sm pl-4 pr-4 mb-3">Go Premiums</button>}
                                        {((active_plan_info.plan_status && active_plan_info.planId === plan.planId && totalIssuedCheque < totalCredit) || (active_plan_info.plan_status && !totalCredit && active_plan_info.planId === plan.planId)) && <button type="button" disabled className="btn btn-primary btn-sm pl-4 pr-4 mb-3">Active Plan</button>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                })}
            </div>

            {/* GST Billing Software Promotion Banner */}
            <style>
                {`
                    .promo-banner {
                        background: #fff;
                        border: 1px solid #f0f0f0;
                        border-radius: 12px;
                        overflow: hidden;
                        position: relative;
                        transition: transform 0.3s ease, box-shadow 0.3s ease;
                        border-left: 4px solid #ED1A3B;
                    }
                    .promo-banner:hover {
                        transform: translateY(-2px);
                        box-shadow: 0 6px 16px rgba(0,0,0,0.08);
                    }
                    .promo-banner::before,
                    .promo-banner::after {
                        display: none;
                    }
                    .promo-icon-box {
                        background: linear-gradient(135deg, #ED1A3B, #F79F1F);
                        border-radius: 10px;
                        padding: 10px;
                        margin-right: 14px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                    }
                    .promo-badge {
                        background: #ED1A3B;
                        color: #fff;
                        font-size: 10px;
                        font-weight: 700;
                        padding: 3px 10px;
                        border-radius: 20px;
                        letter-spacing: 1px;
                        animation: promoPulse 2s ease-in-out infinite;
                    }
                    @keyframes promoPulse {
                        0%, 100% { opacity: 1; transform: scale(1); }
                        50% { opacity: 0.8; transform: scale(1.05); }
                    }
                    .promo-features {
                        display: flex;
                        gap: 16px;
                        flex-wrap: wrap;
                        margin-top: 8px;
                    }
                    .promo-feature-item {
                        display: flex;
                        align-items: center;
                        color: #555;
                        font-size: 12px;
                    }
                    .promo-feature-item i {
                        color: #F79F1F;
                        margin-right: 5px;
                        font-size: 14px;
                    }
                    .promo-btn {
                        background: #ED1A3B;
                        color: #fff;
                        font-weight: 600;
                        border: none;
                        border-radius: 8px;
                        padding: 7px 18px;
                        font-size: 13px;
                        box-shadow: 0 2px 8px rgba(237, 26, 59, 0.25);
                        transition: all 0.3s ease;
                        text-decoration: none;
                        display: inline-flex;
                        align-items: center;
                        gap: 5px;
                    }
                    .promo-btn:hover {
                        background: #d4162f;
                        color: #fff;
                        transform: scale(1.03);
                        box-shadow: 0 4px 12px rgba(237, 26, 59, 0.35);
                        text-decoration: none;
                    }
                    .promo-free-tag {
                        background: #fff8f0;
                        color: #F79F1F;
                        font-size: 11px;
                        font-weight: 600;
                        padding: 2px 10px;
                        border-radius: 6px;
                        border: 1px solid #fde8c8;
                    }
                `}
            </style>
            <div className="row mb-4">
                <div className="col-12">
                    <div className="card promo-banner mb-0">
                        <div className="card-body" style={{ position: "relative", zIndex: 1 }}>
                            <div className="d-flex align-items-center justify-content-between flex-wrap">
                                <div className="d-flex align-items-start">
                                    <div className="d-none d-sm-flex" style={{ marginRight: "14px" }}>
                                        <img src="/mybillbooks-icon.png" alt="MyBillBooks" width="40" height="40" style={{ borderRadius: "8px" }} />
                                    </div>
                                    <div>
                                        <div className="d-flex align-items-center gap-2 mb-1 flex-wrap">
                                            <h5 className="mb-0" style={{ color: "#222", fontWeight: "700", fontSize: "18px" }}>
                                                Bill Books - GST Billing Software
                                            </h5>
                                            <span className="promo-badge">FREE</span>
                                        </div>
                                        <p className="mb-1" style={{ color: "#777", fontSize: "13px" }}>
                                            Simple & fast GST billing for your business. Try it free today!
                                        </p>
                                        <div className="promo-features">
                                            <span className="promo-feature-item">
                                                <i className='bx bx-check-circle'></i> GST Invoices
                                            </span>
                                            <span className="promo-feature-item">
                                                <i className='bx bx-check-circle'></i> Reports
                                            </span>
                                            <span className="promo-feature-item">
                                                <i className='bx bx-check-circle'></i> Multi-user
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div className="mt-3 mt-md-0 d-flex align-items-center gap-2 flex-wrap">
                                    <span className="promo-free-tag">No Credit Card Needed</span>
                                    <a
                                        href="https://mybillbooks.co.in/"
                                        target="_blank"
                                        rel="noreferrer"
                                        className="promo-btn"
                                    >
                                        Try Free <i className='bx bx-right-arrow-alt' style={{ fontSize: "18px" }}></i>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {OrderList.length > 0 &&
                <div className='row mb-4'>
                    <div className='col-sm-12'>
                        <div className="card card-border-shadow-primary h-100">
                            <div className="card-body">
                                <div>
                                    <h6>{t('homePage.transaction.title')}</h6>
                                </div>
                                <div className='table-responsive'>
                                    <table className='table tabl-sm table-striped'>
                                        <thead>
                                            <tr>
                                                <th>{t('homePage.transaction.orderNo')}</th>
                                                <th>{t('homePage.transaction.date')}</th>
                                                <th>{t('homePage.transaction.planName')}</th>
                                                <th>{t('homePage.transaction.transactionId')}</th>
                                                <th>{t('homePage.transaction.amount')}</th>
                                                <th>{t('homePage.transaction.status')}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {OrderList.map((order) => {
                                                return (
                                                    <tr key={order.orderId}>
                                                        <td>{order.orderId}</td>
                                                        <td>{utc_local(order.createdAt)}</td>
                                                        <td>{order.name}</td>
                                                        <td>{order.transactionId}</td>
                                                        <td>{amountFormatUse(order.amount)}</td>
                                                        <td>
                                                            {order.orderStatus === 'Pending' && <span className='border-0 badge bg-info'>Pending</span>}
                                                            {order.orderStatus === 'Completed' && <span className='border-0 badge bg-success'>Completed</span>}
                                                            {order.orderStatus === 'Canceled' && <span className='border-0 badge bg-danger'>Canceled</span>}
                                                        </td>
                                                    </tr>
                                                )
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }

            {invoiceList.length > 0 &&
                <div className='row mb-4'>
                    <div className='col-sm-12'>
                        <div className="card card-border-shadow-primary h-100">
                            <div className="card-body">
                                <div>
                                    <h6>{t('homePage.invoice.title')}</h6>
                                </div>
                                <div className='table-responsive'>
                                    <table className='table tabl-sm table-striped'>
                                        <thead>
                                            <tr>
                                                <th>{t('homePage.invoice.invoiceNo')}</th>
                                                <th>{t('homePage.invoice.invoiceDate')}</th>
                                                <th>{t('homePage.invoice.planName')}</th>
                                                <th>{t('homePage.invoice.totalAmount')}</th>
                                                <th>{t('homePage.invoice.status')}</th>
                                                <th>{t('homePage.invoice.action')}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {invoiceList.map((invoice) => {
                                                return (
                                                    <tr key={invoice.invoiceId}>
                                                        <td>{invoice.invoiceId}</td>
                                                        <td>{utc_local(invoice.createdAt)}</td>
                                                        <td>{invoice.name}</td>
                                                        <td>{amountFormatUse(invoice.totalAmount)}</td>
                                                        <td>
                                                            {invoice.paymentStatus === 'Unpaid' && <span className='text-danger'>{invoice.paymentStatus}</span>}
                                                            {invoice.paymentStatus === 'Paid' && <span className='text-success'>{invoice.paymentStatus}</span>}
                                                            {invoice.paymentStatus === 'Canceled' && <span className='text-danger'>{invoice.paymentStatus}</span>}
                                                        </td>
                                                        <td>
                                                            {invoice.paymentStatus === 'Paid' && <>
                                                                <a href={`${POST_PDF_INVOICE}${invoice.invoiceId}`} target="_blank" rel="noreferrer" className={`btn btn-sm text-info`}><i className="bx bxs-file-pdf"></i></a>
                                                            </>}
                                                        </td>
                                                    </tr>
                                                )
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }


            <div className="modal fade" id="paymentModal" data-bs-backdrop="static" data-bs-keyboard="false">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">

                        {ThankMessage && <>
                            <div className="modal-header">
                                <button type="button" style={{ "position": "absolute", "right": "-30px", "padding": "0px", "top": "0px" }} className="btn btn-sm close" data-bs-dismiss="modal" aria-label="Close">
                                    <i className="bx bx-x" style={{ fontSize: "30px", "color": "#fff" }}></i>
                                </button>
                            </div>
                            <div className='modal-body'>
                                <div className='text-center'>
                                    <svg width={100} className='mb-4' viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" fill="#000000"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"><path fill="#87d185" d="M512 64a448 448 0 1 1 0 896 448 448 0 0 1 0-896zm-55.808 536.384-99.52-99.584a38.4 38.4 0 1 0-54.336 54.336l126.72 126.72a38.272 38.272 0 0 0 54.336 0l262.4-262.464a38.4 38.4 0 1 0-54.272-54.336L456.192 600.384z"></path></g></svg>
                                    <div dangerouslySetInnerHTML={{ __html: t('homePage.transaction.paymentSuccess') }}></div>
                                </div>
                            </div>
                        </>}
                        {!ThankMessage && <>
                            <div className="modal-header">
                                <h5 className="mb-0">{planInfo.name}</h5>
                                <p className='mb-0'>{t('homePage.transaction.orderNo')}. {planInfo.orderId}</p>
                                <button type="button" style={{ "position": "absolute", "right": "-30px", "padding": "0px", "top": "0px" }} className="btn btn-sm close" data-bs-dismiss="modal" aria-label="Close">
                                    <i className="bx bx-x" style={{ fontSize: "30px", "color": "#fff" }}></i>
                                </button>
                            </div>
                            <div className="modal-body pb-0">
                                <div className='text-center mb-3'>
                                    <img className='mb-4 border rounded' src={planInfo.qr_code} alt='Qr code' />
                                    <p className='text-center'><small>{t('homePage.transaction.paymentInfo')}</small></p>
                                    <img src='/upi.png' width="200px" alt='upi icon' />
                                </div>

                            </div>
                            <div className="modal-footer">
                                <div className="input-group mb-3">
                                    <input type="text" onChange={handleInputChange} name='transactionId' value={form_inputs.transactionId} className="form-control" placeholder="Transaction Id" />
                                    <button onClick={submit} className="btn btn-primary" disabled={ButtonDisabled}> {ButtonDisabled && <i className="fa fa-spinner me-2 fa-spin"></i>} {t('submit')}</button>
                                </div>
                            </div>
                        </>}
                    </div>
                </div>
            </div>
        </>
    );
}

export default Dashboard;